import React, {Component} from "react";
import BannderHead from "../../components/layout/BannderHead";
import axios from "axios";
import Pagination from "../../components/Pagination";
import DatePicker from "react-datepicker2";
import {groupBy, entries} from "lodash";

var moment = require('moment-jalaali')


export default class AdminOrdersDescriptionListPage extends Component {
    state = {
        orders: [],
        pagination: {},
        translate: {
            fa: {
                send: "ارسال سفارش",
                fast: "ارسال فوری",
                inPerson: "تحویل حضوری",
                normal: "ارسال عادی"
            }

        }
    }

    constructor() {
        super();
        this.state.isShow = 'daily';
    }

    async componentDidMount() {
        await this.getOrders();

    }


    getOrders = async () => {
        let URL = '';
        if (this.props.today) {
            URL = window.admin_base_URL + '/orders/ordersByClient/today/'
        } else {
            URL = window.admin_base_URL + '/orders/ordersByClient'
        }

        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get('page');
        if (page) URL = window.admin_base_URL + '/orders/ordersByClient?page=' + page
        let pagination = {};
        let data = [];
        await axios.get(URL)
            .then(res => {
                data = res.data.result
                pagination = res.data.pagination

            }).catch(err => {
                console.error(err)
            })
        let source = data.filter((value, index, self) =>
                index === self.findIndex((t) => (
                    t.client._id === value.client._id
                ))
        )
        this.setState(() => {
            return {orders: source, pagination: pagination};
        });
    }



    render() {


        let {orders, pagination} = this.state;
        let {today} = this.props;

        return (
            <div className="ps-page pb-75">
                <BannderHead className="no-print" title={'مشتریان سفارشات امروز'}/>
                <BannderHead className="just-print" title={'مشتریان سفارشات ' + moment(new Date()).format('jYYYY/jMM/jDD')}/>


                <div className='ml-4 mb-4 d-flex'>
                    <div className="w-50 text-right">
                        <span>تعداد کل: {orders.length}</span>&nbsp;;&nbsp;
                        <span>تعداد نمایش در صفحه : {pagination.limit}</span>&nbsp;;&nbsp;
                        <span>شماره صفحه : {pagination.page}</span>
                    </div>
                    <div className="w-50">
                        <Pagination pagination={pagination}/>
                    </div>
                </div>

                <table className="table table-hover table-striped text-right mb-4 font-big-print">
                    <thead>
                    <tr>
                        <th scope="col">نام فروشگاه</th>
                        <th scope="col">نام مشتری</th>
                        <th scope="col">تلفن مشتری</th>
                        <th scope="col">آدرس فروشگاه</th>
                    </tr>
                    </thead>
                    <tbody>
                    {orders.map((item, index) => {
                        return <tr key={index}>
                            <td className="w-print-30">
                                <div className="bolder">{item.client.shopTitle}</div>
                            </td>
                            <td>
                                <div >{item.client.name}</div>
                            </td>
                            <td>
                                <div >{item.client.phone}</div>
                            </td>
                            <td>
                                <div >{item.client.address}</div>
                                <div className='mb-10 mb-print-0'>کدپستی: {item.client.postCode}</div>
                            </td>
                        </tr>
                    })}
                    </tbody>
                </table>
                <Pagination pagination={pagination}/>
            </div>
        );
    }
}
